module.exports = __webpack_public_path__ + "img/pencil.49f920f5.png";